import {
  SEARCH_MOBILITY,
  SEARCH_MOBILITY_FAILURE,
  SEARCH_MOBILITY_SUCCESS,
  SEARCH_REVIEW_SNAPSHOTS,
  SEARCH_REVIEW_SNAPSHOTS_FAILURE,
  SEARCH_REVIEW_SNAPSHOTS_SUCCESS,
  SEARCH_REVIEW_LOGS,
  SEARCH_REVIEW_LOGS_FAILURE,
  SEARCH_REVIEW_LOGS_SUCCESS,
  SEARCH_CARE_PLAN,
  SEARCH_CARE_PLAN_FAILURE,
  SEARCH_CARE_PLAN_SUCCESS,
  SEARCH_WARNING,
  SEARCH_WARNING_FAILURE,
  SEARCH_WARNING_SUCCESS,
  SEARCH_MAPPED_PLAN,
  SEARCH_MAPPED_PLAN_FAILURE,
  SEARCH_MAPPED_PLAN_SUCCESS,
} from "./constants";

// Search
export const searchMobility = (payload) => ({
  type: SEARCH_MOBILITY,
  payload,
});
export const searchMobilitySuccess = (payload) => ({
  type: SEARCH_MOBILITY_SUCCESS,
  payload,
});
export const searchMobilityFailure = (payload) => ({
  type: SEARCH_MOBILITY_FAILURE,
  payload,
});

export const searchReviewSnapshots = (payload) => ({
  type: SEARCH_REVIEW_SNAPSHOTS,
  payload,
});
export const searchReviewSnapshotsSuccess = (payload) => ({
  type: SEARCH_REVIEW_SNAPSHOTS_SUCCESS,
  payload,
});
export const searchReviewSnapshotsFailure = (payload) => ({
  type: SEARCH_REVIEW_SNAPSHOTS_FAILURE,
  payload,
});

export const searchReviewLogs = (payload) => ({
  type: SEARCH_REVIEW_LOGS,
  payload,
});
export const searchReviewLogsSuccess = (payload) => ({
  type: SEARCH_REVIEW_LOGS_SUCCESS,
  payload,
});
export const searchReviewLogsFailure = (payload) => ({
  type: SEARCH_REVIEW_LOGS_FAILURE,
  payload,
});

export const searchCarePlan = (payload, callback) => ({
  type: SEARCH_CARE_PLAN,
  payload,
  callback,
});
export const searchCarePlanSuccess = (payload) => ({
  type: SEARCH_CARE_PLAN_SUCCESS,
  payload,
});
export const searchCarePlanFailure = (payload) => ({
  type: SEARCH_CARE_PLAN_FAILURE,
  payload,
});

export const searchWarning = (payload, callback) => ({
  type: SEARCH_WARNING,
  payload,
  callback,
});
export const searchWarningSuccess = (payload) => ({
  type: SEARCH_WARNING_SUCCESS,
  payload,
});
export const searchWarningFailure = (payload) => ({
  type: SEARCH_WARNING_FAILURE,
  payload,
});

export const searchMappedPlan = (payload, callback) => ({
  type: SEARCH_MAPPED_PLAN,
  payload,
  callback,
});
export const searchMappedPlanSuccess = (payload) => ({
  type: SEARCH_MAPPED_PLAN_SUCCESS,
  payload,
});
export const searchMappedPlanFailure = (payload) => ({
  type: SEARCH_MAPPED_PLAN_FAILURE,
  payload,
});
